export const faqData = {
  id: 'faq-items',
  className: 'panel d-flex align-items-center',
  mainContent: {
    id: 0,
    header: 'General Questions',
    content:
      "Here are answers to a few of our most frequently asked questions. Don't see what you're looking for?",
    link: {
      url: 'mailto:guestservices@jetsuite.com',
      label: 'Contact Us'
    }
  },
  faqItems: [
    {
      id: 1,
      header:
        'What information does JetSuite require in order to complete my reservation?',
      content: [
        '• Departure & Arrival Airport(s)',
        '• Passenger Legal Names',
        '• Individual Passenger Weights (lbs)',
        '• Passenger Dates of Birth',
        '• Expected Luggage (# of bags & lbs)',
        '• Lead Passenger Email Address and Day Of Flight',
        '• Phone Number'
      ]
    },

    {
      id: 2,
      header: 'What time do I have to arrive at the airport?',
      content: [
        'We encourage Guests to arrive 15 minutes prior to scheduled departure. Upon your arrival, our gracious flight crew will be ready to handle and load any luggage you may have.',
        'Please keep in mind the terms of your purchased agreement, as flights must depart within 15 minutes of the scheduled departure time - or 30 minutes if you are a SuiteKey member. Late arrivals run the risk of incurring additional charges or JetSuite’s inability to perform the flight.'
      ]
    },

    {
      id: 4,
      header: 'Are flights conducted with two pilots?',
      content: [
        'Yes, your JetSuite flight will always be operated by two captain-qualified pilots.'
      ]
    },

    {
      id: 5,
      header: 'How much flying experience do JetSuite pilots typically have?',
      content: [
        'JetSuite’s pilots are among the highest qualified in the charter industry, averaging over 8,000 hours of flight time. Subject to a meticulous hiring process, each pilot must meet exceptional qualifications including a minimum each of 3,000 hours flying time, 1,000 hours turbine time and 500 hours of jet PIC time - and possess an Airline Transport Pilot Certificate (the FAA’s most stringent pilot qualification) and a First Class Medical Certificate. To reinforce their skills, JetSuite pilots return annually to CAE Simuflite for demanding training in state-of-the-art, full-motion flight simulators.'
      ]
    },
    {
      id: 6,
      header: 'Does JetSuite have a safety rating?',
      content: [
        'Safety is always our top priority, and JetSuite has been awarded the ARG/US Platinum rating - the highest achievable in civil aviation. The ARG/US audit verifies an air carrier functions in a manner most conducive to safe operations. JetSuite is also an IS-BAO certified operator.'
      ]
    },
    {
      id: 7,
      header:
        'What is the maximum number of fractional owners on a given airplane?',
      content: [
        'Zero. We own all of our aircraft, and all fleet time is made available to clients via JetSuite’s Guest Service Executives and scheduling software. '
      ]
    },
    {
      id: 8,
      header: 'Am I a part owner of a jet when I become a SuiteKey Member?',
      content: [
        'No. Shared ownership of an aircraft creates many complexities, competing interests, operational, insurance, and tax liabilities. All aircraft in JetSuite’s fleet are owned by JetSuite or leased from an individual owner. JetSuite holds 100% authority over the use of any jet in its fleet - no owner approvals are necessary. If you are interested in taking advantage of JetSuite’s whole airplane owner program, please call a JetSuite sales representative at (866) 779-7770.'
      ]
    },
    {
      id: 9,
      header: 'Does flying under Part 135 restrict my ability to fly?',
      content: [
        'As safety is our top priority, restrictions may apply - but with good reason.',
        'On occasion privately-owned aircraft will fly when we do not, as they may operate under Part 91 of the Federal Aviation Regulations. Part 91 regulations are appropriate for parties who own their aircraft, understand the various risks of flight operations and are willing to assume operational control and liabilities given the increased risk of some flights.',
        'JetSuite - ranked ARG/US Platinum – retains full operational control. Our compliance with Part 135 regulations means that JetSuite operations are more stringent and provide a level of safety beyond Part 91, including limiting operations in reduced visibility, subjecting pilots to background and drug tests, and restricting their duty time.'
      ]
    },
    /*{
      id: 10,
      header: 'How are airport fees calculated?',
      content: [
        'Airport fees are determined by a combination of historical data and actual costs. This allows JetSuite to deliver competitive pricing based on individual and specific travel needs. Airport fee inclusions are as follows:',
        '• Airport Fuel Price',
        '• International and Handling Fees',
        '• Landing Fees',
        '• Ground Power Unit (GPU)',
        '• Parking',
        '• Other (Hangar, De-Icing)'
      ]
    },*/
    {
      id: 11,
      header: 'What should I expect from JetSuite after making a reservation?',
      content: [
        'Once a flight reservation has been confirmed, guest will receive a PDF of the itinerary outlining all customer, flight, and private terminal information along with confirmation of any previously requested services. The day prior to scheduled departure, customers will receive a confirmation phone call from JetSuite Guest Services ensure accurate trip details, which is then followed by an e-mail containing aircraft tail assignment and crew names for the flight.'
      ]
    },
    {
      id: 12,
      header: 'Why does JetSuite request passenger weights?',
      content: [
        'Recording passenger and luggage weight is an FAA requirement, and helps ensure JetSuite flights are operated safely and efficiently.'
      ]
    },
    {
      id: 13,
      header:
        'Since JetSuite does not provide tail numbers, how can I track my flight or arrange ground transportation?',
      content: [
        'All JetSuite flights are operated using the call sign “Red Stripe” followed by a 3-digit identifier (ex. Red Stripe 456 - RSP456). This method is identical to commercial flights such as Southwest Airlines or JetBlue (SWA196 or JBU270). This flight number is the only way to track the progress of a flight, using websites such as www.flightaware.com, and can also be given to ground transportation and catering providers. Due to JetSuite’s fully interchangeable fleet, aircraft tail numbers often change, while the flight numbers do not.'
      ]
    },
    {
      id: 14,
      header: 'What amenities can I find on board a JetSuite aircraft?',
      content: [
        '• Amenity kit provided by Red Flower',
        '• Organic blanket provided by Coyuchi',
        '• Catering provided by Air Culinaire by request',
        '• Gourmet assortment of snacks',
        '• Wine and Spirits'
      ]
    },
    {
      id: 15,
      header: 'Do the aircraft have a bathroom?',
      content: [
        'Yes. The Phenom 100, Phenom 300, and Legacy 650 all have a lavatory with a flushing toilet, located in the aft of the aircraft. We do encourage you to utilize the facilities at the FBO prior to flight for additional privacy and convenience.'
      ]
    },
    {
      id: 16,
      header: 'What exactly is an “FBO”?',
      content: [
        'The term “FBO” is an acronym for “Fixed‐Base Operator” and refers to the private terminal. These locations provide passenger and aircraft services similar to those found in any commercial terminal. FBOs are generally located away from the main commercial airline terminals and offer ease to boarding and arrival.'
      ]
    },
    {
      id: 17,
      header: 'How many passengers can fit on the aircraft?',
      content: [
        'The Phenom 100s have four identical club seats and the Phenom 300s have capacity for 7 passengers. Please tell us if your passenger count changes, so we can plan your flight accordingly.'
      ]
    },
    {
      id: 18,
      header: 'Are pets welcome on JetSuite flights?',
      content: [
        'Absolutely. Pets are welcome (excluding SuiteDeals) and they can enjoy the main cabin with you! Pet passengers must be restrained in accordance with FAA regulations for taxi, takeoff, and landing. If your pet is small or an anxious flier, it is advisable to keep the pet in a pet carrier for the duration of the flight.'
      ]
    },
    {
      id: 19,
      header: 'How much luggage can I bring on my flight?',
      content: [
        'Aircraft types have distinct limits in terms of baggage weight capacity. We suggest you provide JetSuite with your anticipated luggage weight and volume in advance, so you may arrange accordingly.Phenom 100 total baggage weight capacity is 250lbs and the Phenom 300 total baggage weight capacity is 400lbs.'
      ]
    },
    {
      id: 20,
      header: 'Can the weight of my luggage impact the flight?',
      content: [
        "Yes. Weight can have a dramatic effect on aircraft performance as well as the aircraft's takeoff and landing distance. If the combined weight of passengers and luggage is particularly heavy, the pilots may determine that off-loading fuel may be required to keep the aircraft under maximum takeoff weight, and may warrant additional fueling stops."
      ]
    },
    {
      id: 21,
      header:
        'Do high altitude/mountain airports cause performance problems for aircraft?',
      content: [
        'There are several factors that affect the runway performance of an aircraft. Among these factors are airport elevation, temperature, weight of the aircraft, winds and runway condition. As the air increases in temperature, its density decreases. This is particularly problematic for aircraft departing from high elevation airports because the air is already less dense at higher elevations.'
      ]
    }
  ]
};



// WEBPACK FOOTER //
// ./src/components/FAQ/faq-data.js